import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

const iconWrap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function CategorySection() {
  return (
    <section id="categories" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <SectionHeading
          kicker="主题分类"
          title="从六个角度看懂一场瓜"
          desc="不同问题需要不同的看法：想知道发生了什么去看时间线，想判断真假就去看鉴定，想了解人就去翻档案。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((item, index) => (
            <Reveal key={item.slug} delay={index * 70}>
              <Link
                to={`/category/${item.slug}`}
                className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`flex h-12 w-12 items-center justify-center rounded-md ${iconWrap[item.tone]}`}
                  >
                    <i className={`${item.icon} text-2xl`} />
                  </span>
                  <span className="font-heading text-2xl font-black text-background-300">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700">
                  {item.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <p className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <span>已收录 {item.count} 条</span>
                  <span className="flex items-center gap-1 text-primary-700">
                    进入栏目
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                  </span>
                </p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}